import "./EmployeeAbsence.css";
import { useEffect, useState } from "react";
import CancelButton from "../../../../../sharedComponents/cancelButton/CancelButton";
import PrimaryButton from "../../../../../sharedComponents/primaryButton/PrimaryButton";
import { Modal } from "react-bootstrap";
import axios from "axios";
import { CustomProvider, DatePicker, SelectPicker } from "rsuite";
import EmployeeCreationAbsence from "./creation/EmployeeCreationAbsence";
import { Calendar } from "react-multi-date-picker";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import AbsenceList from "./absenceList/AbsenceList";
import { deDE } from 'rsuite/locales';
import Logout from "../../../../../sharedComponents/Logout";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { MonthNames } from "../../../../../sharedComponents/MonthNames";

const weekDays = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"];
const months = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"]

function EmployeeAbsence(props){
    /** 
     * when creating vacation always on the first of month;
     * check in what month the absence-period is 
     * hours in one absence-period is same 
     * ignore specific day = true
     * 
     * Darstellung: in Tabelle mit vier Listen (ähnlich wie Footer) um bezahlten/ unbezahlten Urlaub/Krankheit
    */

    const [refresh, setRefresh] = useState(false);

    const [selectedMonth, setSelectedMonth] = useState(new Date());

    // "month" = bisherige Monatsansicht, "year" = Jahresansicht
    const [selectedViewMode, setSelectedViewMode] = useState("month");
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

    // Removing Modal
    const [openRemovingModal, setOpenRemovingModal] = useState(false);
    const handleCloseRemovingModal = () => {
        setRemovingAbsenceError(false);
        setOpenRemovingModal(false);
    }

    const [removingAbsenceError, setRemovingAbsenceError] = useState(false);

    const [selectedDateArray, setSelectedDateArray] = useState([]);
    const [openDetailModal, setOpenDetailModal] = useState(false);
    const handleCloseDetailModal = () => {
        setOpenDetailModal(false);
    }

    const [selectedId, setSelectedId] = useState("");
    const [absences, setAbsences] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                axios.get('absence/getAllAbsencePeriodsForEmployeeWithId?id=' + new URLSearchParams(window.location.search).get("employeeId")).then(results => {
                    setAbsences(results.data);
                })
            } catch (error){
                Logout();
            }
        }
        fetchData();
    }, [refresh])

    function sendDeleteRequest() {
        axios.delete('absence/deleteAbsencePeriodWithId?id=' + selectedId, {
        }).then(() => {
            handleCloseRemovingModal();
            setRemovingAbsenceError(false);
            setRefresh(!refresh);
        }).catch(() => setRemovingAbsenceError(true)); 
    }

    

    function terminatedAbsenceModal() {
        return (
            <Modal
                show={openDetailModal}
                onHide={handleCloseDetailModal}
                keyboard={true}
            >
                <Modal.Header>
                        <Modal.Title>Abwesenheit</Modal.Title>
                        <button type="button" className="close" aria-label="Close" onClick={handleCloseDetailModal}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </Modal.Header>
                    <Modal.Body className="detail-view-calendar">
                        <Calendar 
                            multiple
                            format="DD.MM.YYYY"
                            readOnly
                            weekDays={weekDays}
                            months={months}
                            highlightToday={false}
                            value={selectedDateArray} 
                            weekStartDayIndex={1}
                            plugins={[
                                <DatePanel sort="date" header="Ausgewählt" removeButton={false}/>
                            ]}
                        /> 
                    </Modal.Body>
                    <Modal.Footer>
                        <PrimaryButton text="Okay" onClick={handleCloseDetailModal} />
                    </Modal.Footer>
            </Modal>
        )
    }

    function removeAbsenceModal() {
        return (
            <Modal
                show={openRemovingModal}
                onHide={handleCloseRemovingModal}
                keyboard={true}
            >
                <Modal.Header>
                        <Modal.Title>Abwensenheit löschen</Modal.Title>
                        <button type="button" className="close" aria-label="Close" onClick={handleCloseRemovingModal}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </Modal.Header>
                    <Modal.Body>
                        <p>Möchten Sie wirklich diese Abwesenheit löschen?</p>  
                        {removingAbsenceError && <p className="red">Ein Fehler ist aufgetreten.</p>}              
                    </Modal.Body>
                    <Modal.Footer>
                        <CancelButton text="Abbrechen" onClick={handleCloseRemovingModal} />
                        <PrimaryButton text="Abwesenheit löschen" onClick={() => sendDeleteRequest()} />
                    </Modal.Footer>
            </Modal>
        )
    }

    const handleTodayClick = () =>  {
        const newDay = new Date();
        setSelectedMonth(newDay);
        setSelectedYear(newDay.getFullYear());
    }

    const handleViewModeChange = (event, newViewMode) => {
        if (newViewMode === null) return;
        setSelectedViewMode(newViewMode);
    }

    const generateYearOptions = () => {
        const currentYear = new Date().getFullYear();
        const years = [];
        for (let year = currentYear - 10; year <= currentYear + 10; year++) {
            years.push({ label: year.toString(), value: year });
        }
        return years;
    }

    const getSelectedPeriodText = () => {
        if (selectedViewMode === "month" && selectedMonth !== null) {
            return MonthNames[selectedMonth.getMonth()] + " " + selectedMonth.getFullYear();
        }
        return selectedYear.toString();
    }

    const getPrintHeader = () => {
        const employeeName = [props.firstName, props.lastName].filter(Boolean).join(" ");
        return employeeName + " – Abwesenheiten " + getSelectedPeriodText();
    }

    const handlePrint = () => {
        const previousTitle = document.title;
        document.title = getPrintHeader().replace(" – ", " - ");
        window.print();
        document.title = previousTitle;
    }

    return (
            <>
                <EmployeeCreationAbsence refresh={refresh} setRefresh={setRefresh} absences={absences} />
                {removeAbsenceModal()}
                <div className="employee-absence-print-area">
                    <div className="employee-absence-print-header">
                        {getPrintHeader()}
                    </div>
                    <div className="employee-absence-select">
                        <ToggleButtonGroup
                            value={selectedViewMode}
                            onChange={handleViewModeChange}
                            color="primary"
                            exclusive
                        >
                            <ToggleButton value="month">Monat</ToggleButton>
                            <ToggleButton value="year">Jahr</ToggleButton>
                        </ToggleButtonGroup>
                        {selectedViewMode === "month" ?
                            <CustomProvider locale={deDE}>
                                <DatePicker
                                    className="dashboard-datepicker"
                                    cleanable={false}
                                    label="Monat"
                                    oneTap
                                    required
                                    format="MMM yyyy"
                                    size="lg"
                                    placeholder="Startmonat"
                                    value={selectedMonth}
                                    onSelect={(value) => setSelectedMonth(value)}
                                />
                            </CustomProvider>
                            :
                            <SelectPicker
                                data={generateYearOptions()}
                                style={{ width: 200 }}
                                value={selectedYear}
                                onChange={(value) => {
                                    if (value === null || value === undefined) return;
                                    setSelectedYear(value);
                                }}
                                cleanable={false}
                                placeholder="Ausgewähltes Jahr"
                            />
                        }
                        <PrimaryButton text="Heute" onClick={handleTodayClick} />
                        <PrimaryButton text="Drucken" onClick={handlePrint} />
                    </div>
                    <div className="month-container">    
                        <AbsenceList 
                            absences={absences}
                            setDateArray={setSelectedDateArray} 
                            setSelectedId={setSelectedId} 
                            selectedMonth={selectedViewMode === "month" ? selectedMonth : null}
                            selectedYear={selectedViewMode === "month" && selectedMonth !== null ? selectedMonth.getFullYear() : selectedYear}
                            setOpenDetailModal={setOpenDetailModal}
                            setOpenRemovingModal={setOpenRemovingModal}
                        />
                    </div>
                </div>
                {terminatedAbsenceModal()}
            </>
        )
}

export default EmployeeAbsence;